import { render, staticRenderFns } from "./CourseConstructor.vue?vue&type=template&id=f4cf759c&scoped=true&"
import script from "./CourseConstructor.vue?vue&type=script&lang=js&"
export * from "./CourseConstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cf759c",
  null
  
)

export default component.exports